import React from 'react';

import StatusLabel from '@/components/EditorBuilder/StatusLabel';
import { ResourceStatusEnum, VersionConfig } from '@/types/schema';

import PreviewMenu from './PreviewMenu';

const TAGS_MAP = [ResourceStatusEnum.Draft, ResourceStatusEnum.Published];

function PreviewLabel(props: {
  status?: ResourceStatusEnum;
  previewId?: string;
  setPreviewId: (previewRootBlockId: string) => void;
  versionConfigs: VersionConfig[];
}) {
  const { status, previewId, setPreviewId, versionConfigs } = props;

  if (!previewId || !status) {
    return null;
  }

  if (status === ResourceStatusEnum.UnpublishedChanges) {
    return (
      <PreviewMenu
        previewId={previewId}
        setPreviewId={setPreviewId}
        versionConfigs={versionConfigs}
      />
    );
  }

  return TAGS_MAP.includes(status) ? <StatusLabel status={status} /> : null;
}

export default React.memo(PreviewLabel);
